import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import DebriefingSummary from './DebriefingSummary';
import MetricsBreakdown from './MetricsBreakdown';
import CustomerResultsTable from './CustomerResultsTable';
import CustomerDetailModal from './CustomerDetailModal';
import DecisionTimeline from './DecisionTimeline';
import SkillGapsSection from './SkillGapsSection';
import RecommendationsPanel from './RecommendationsPanel';
import ActionButtons from './ActionButtons';

export default function Debriefing(props) {
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-[1400] flex items-center justify-center bg-black/90 backdrop-blur-sm"
      >
        <motion.div
          initial={{ x: '100%', opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: '100%', opacity: 0 }}
          transition={{ type: 'spring', damping: 25, stiffness: 200 }}
          className="w-full max-w-6xl max-h-[95vh] overflow-y-auto overflow-x-hidden bg-slate-950 rounded-2xl shadow-2xl"
        >
          {/* Header */}
          <div className="sticky top-0 z-10 bg-slate-950/95 backdrop-blur-sm border-b border-white/10 px-8 py-4">
            <h1 className="text-2xl font-bold text-gray-50">
              Scenario Complete: {props.scenario.name}
            </h1>
          </div>

          {/* Content */}
          <div className="px-8 py-6 space-y-8 overflow-x-hidden">
            <DebriefingSummary finalScore={props.finalScore} benchmarks={props.benchmarks} />
            <MetricsBreakdown breakdown={props.finalScore.breakdown} />
            <CustomerResultsTable
              results={props.customerResults}
              onCustomerClick={setSelectedCustomer}
            />
            {props.timelineEvents && props.timelineEvents.length > 0 && (
              <DecisionTimeline events={props.timelineEvents} />
            )}
            {props.skillGaps && props.skillGaps.length > 0 && (
              <SkillGapsSection gaps={props.skillGaps} />
            )}
            {props.recommendations && props.recommendations.length > 0 && (
              <RecommendationsPanel recommendations={props.recommendations} />
            )}
          </div>

          {/* Footer */}
          <ActionButtons onBack={props.onExit} />

          {/* Modal */}
          {selectedCustomer && (
            <CustomerDetailModal
              result={selectedCustomer}
              onClose={() => setSelectedCustomer(null)}
            />
          )}
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
